import { render, staticRenderFns } from "./EmploymentPeriodEditor.vue?vue&type=template&id=566b954e&"
import script from "./EmploymentPeriodEditor.vue?vue&type=script&lang=js&"
export * from "./EmploymentPeriodEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmploymentPeriodEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports